"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScopes = getScopes;
exports.hasScope = hasScope;
exports.hasReadOnlyScope = hasReadOnlyScope;

var _underscore = require("underscore");

function getScopes(state) {
  return state.scopes.userScopes;
}

function hasScope(state, scopeToCheck) {
  return (0, _underscore.contains)(getScopes(state), scopeToCheck);
}

function hasReadOnlyScope(state) {
  return !(0, _underscore.contains)(getScopes(state), 'lead-flows-write');
}